import { useCallback } from 'react'
import addIcons from '../../assets/icons/generals/add.svg'
import { useDropzone } from 'react-dropzone'
import { useRequestProcessor } from '../../api/requestProcessor'
import { uploadImage } from '../../api/upload-files'
import { toast } from 'react-toastify'

const AddPictureCard = ({ onAddImage }) => {


    // DROPZONE CONFIG
    const { Mutate } = useRequestProcessor()

    const { mutate: mutateGallery } = Mutate(
        "uploadgalleryImage",
        uploadImage,
        {
            onSuccess: (data) => {
                toast.success("عکس با موفقیت آپلود شد", {
                    autoClose: 2500,
                    progress: false,
                })
                onAddImage({
                    thumb: data.images.thumb
                })
                //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );
    const onDrop = useCallback(acceptedFiles => {

        let formData = new FormData();
        formData.append("images", acceptedFiles[0])
        mutateGallery(formData)
    }, [])


    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop, accept: {
            'image/jpeg': [],
            'image/jpg': [],
            'image/png': [],
        }
    })


    return (
        <form className="galleryCard"{...getRootProps()} >

            <div className="galleryCard__background bg-gray-100"></div>
            <div className='absolute top-0 w-full h-full flex cursor-pointer
            flex-col justify-center items-center text-bs-black font-bold' >
                <input {...getInputProps()} />
                {
                    <>
                        <img src={addIcons} className='w-20 bg-white p-4 rounded-full cursor-pointer' alt="حذف عکس" />
                        <p className='py-2'>یا</p>
                        <p>عکس را اینجا بکشید</p>
                    </>
                }
            </div>
        </form>
    )
}

export default AddPictureCard